<template>
  <div>
    <div style="margin-bottom: 10px;">
      <el-row>
        <el-col>
          <el-button size="mini" @click="setComponentId('CustomerSaleMain')">返回</el-button>
        </el-col>
      </el-row>
    </div>
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%" height="600">
          <el-table-column
            prop="id"
            label="业主编号"
            width="180">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEdit(scope.row)">{{scope.row.id}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="业主名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="contract_id"
            label="合同编号"
            width="180">
          </el-table-column>
          <el-table-column
            prop="contract_date"
            label="签订日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="receive_date"
            label="交付日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="cancel_date"
            label="取消日期"
            width="180">
          </el-table-column>
          <el-table-column
            prop="consultant"
            label="	操作人"
            width="180">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerSaleHistory",
  data(){
    return {
      where:{},
      form:{},
      loading:false,
      pageData:{
        list: [],
        total: 0,
        page:1,
        pageSize:20
      },
      tableData:[]
    }
  },
  inject:['commonObj','setComponentId','componentId'],
  watch:{
    "commonObj.house_id":function (n,o) {
      this.where={}
      this.where.house_id=n;
      this.componentId===3&&this.getList();
    }
  },
  mounted() {
    this.where.house_id=this.commonObj.house_id;
    // this.where.house_id&&this.getList();
  },
  activated() {
    this.where.house_id&&this.getList();
  },
  methods:{
    getList(){
      const that=this;
      that.loading=true;
      let where=reObject(that.where)
      ERP.getRequest({
        url: "admin/HouseSale/getList",
        data: {
          where: JSON.stringify(where),
          page: that.pageData.page,
          page_size: that.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData = res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    showEdit(item){
      console.log(item)
      this.commonObj.id=item.id;
      this.commonObj.house_id=item.house_id;
      this.setComponentId("CustomerSaleMain");
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerSaleHistory.vue